/* tslint:disable */
import {
  OfficeVisitor
} from '../index';

declare var Object: any;
export interface VisitorCompanyInterface {
  "name": string;
  "id"?: any;
  visitors?: OfficeVisitor[];
}

export class VisitorCompany implements VisitorCompanyInterface {
  "name": string;
  "id": any;
  visitors: OfficeVisitor[];
  constructor(data?: VisitorCompanyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VisitorCompany`.
   */
  public static getModelName() {
    return "VisitorCompany";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VisitorCompany for dynamic purposes.
  **/
  public static factory(data: VisitorCompanyInterface): VisitorCompany{
    return new VisitorCompany(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VisitorCompany',
      plural: 'VisitorCompanies',
      path: 'VisitorCompanies',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        visitors: {
          name: 'visitors',
          type: 'OfficeVisitor[]',
          model: 'OfficeVisitor',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'visitorCompanyId'
        },
      }
    }
  }
}
